import classes from "./category.module.css";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { categories } from "../../../../../Config/MainCategory";
import { useDispatch } from "react-redux";
import { closeCatDD } from "../../../../../Redux/Reducer/dropdown";

const CategorySecCards = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const gotoCategoriesPage = useCallback(
    (category) => {
      navigate(`/${category}`, {
        replace: true,
      });

      dispatch(closeCatDD());
    },
    [navigate]
  );

  return categories.map((element) => (
    <div key={element} className={classes.categoryCol}>
      <div
        onClick={() => gotoCategoriesPage(element)}
        className={classes.categoryBox}
      >
        <div className={classes.categoryImg}>
          <img
            src={require(`./CategoryImages/${element}.png`).default}
            loading="lazy"
            alt={element}
            width="100%"
            height="100%"
          />
        </div>
        <h4>{element}</h4>
      </div>
    </div>
  ));
};
export default CategorySecCards;
